<div class="wccard p-3 mb-1">
    <app-companypage-ai [requestaidata]="profiledataAI" [currentCompanyName]="currentCompanyName" [insightstabname]="'profiles'" [totalcount]="totalFunctionResultCount" ></app-companypage-ai>
</div>
<div class="wccard p-3 mb-2">
    <div class="row">
        <div class="col">
            <p class="f-16 font-weight-600 mb-4">Department</p>
        </div>
        <div class="col">
            <p class="f-16 font-weight-600 mb-4">Seniority</p>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6" style="border-right: 1px solid #d9d9d9;">
            <div class=" d-flex justify-content-center align-items-center">
                <div *ngIf="!functionsData?.data?.length">
                    <div class="loader text-center" *ngIf="!departmentemptystate">
                        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    </div>
                    <div class="text-center" *ngIf="departmentemptystate">
                        <p class="text-center small p-5">No data to display</p>
                    </div>
                </div>

                <fusioncharts width="100%" type="doughnut2d" [dataSource]="functionsData" *ngIf="functionsData?.data?.length">
                </fusioncharts>
            </div>
        </div>
        <div class="col-md-6">
            <div class="d-flex justify-content-center align-items-center">
                <div *ngIf="!seniorityData?.data?.length">
                    <div class="loader text-center" *ngIf="!seniorityemptystate">
                        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    </div>
                    <div class="text-center" *ngIf="seniorityemptystate">
                        <p class="text-center small p-5">No data to display</p>
                    </div>
                </div>

                <fusioncharts width="100%" type="doughnut2d" [dataSource]="seniorityData" *ngIf="seniorityData?.data?.length">
                </fusioncharts>
            </div>
        </div>
    </div>
</div>

<div class="wccard p-3 mb-1" *ngIf="allKeyPeopleData?.length && keyPeoplePDLIds?.length && !showLoaderForKeyPeople">
    <p class="f-16 font-weight-600 mb-2">Key People</p>
    <p class="text-9696 mb-2">Total Candidates({{allKeyPeopleData?.length}})</p>
    <div class="d-flex flex-wrap mb-2">
        <div class="col-4 mb-2 pl-0 pr-2" *ngFor="let candidateDetails of keyPeopleData; let i = index">
           <app-candidate-card-view [candidateDetails]="candidateDetails" [i]="i"></app-candidate-card-view>
        </div>
    </div>
</div>

<div *ngIf="keyPeopleTotalCount > 6" class="d-flex justify-content-center wccard ng-star-inserted mb-2" >
    <ngb-pagination [collectionSize]="keyPeopleTotalCount" [maxSize]="5" aria-label="Custom pagination" [pageSize]="keyPeoplePageSize" rotate="false" (pageChange)="setPageKeyPeople($event)" [(page)]="keyPeopleCurrentPage" [ellipses]="false">
      <ng-template ngbPaginationPrevious> Previous </ng-template>
      <ng-template ngbPaginationNext> Next </ng-template>
    </ngb-pagination>
</div>

<div *ngIf="showLoaderForKeyPeople">
    <div class="loader text-center" *ngIf="!keyemptystate">
        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
    </div>
    <div class="text-center" *ngIf="keyemptystate">
        <p class="text-center small p-5">No Data Available</p>
    </div>
</div>
